// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const DaysOldDirective = () => ({
   replace: true,
   templateUrl: '/assets/daysOldList.html',
   controller: DaysOldController,
   controllerAs: 'vm',

   bindToController: {
      facet: '='
   }
})

class DaysOldController {
   $scope: any
   appState: any
   events: any
   searchScopeService: SearchScopeService
   constructor($scope: any, appState: any, events: any, searchScopeService: SearchScopeService) {
      this.isRangeSelected = this.isRangeSelected.bind(this)
      this.toggle = this.toggle.bind(this)
      this.$scope = $scope
      this.appState = appState
      this.events = events
      this.searchScopeService = searchScopeService
   }

   isRangeSelected(days: any) { 
      return this.appState.params.rf && _(this.appState.params.rf).some((f: any) => (f.indexOf("NewRecords") > -1) && (f.indexOf(days) > -1))
   }

   isRangeSelectedByScope(days: any) { 
      return this.appState.searchScopeParams.rf && _(this.appState.searchScopeParams.rf).some((f: any) => (f.indexOf("NewRecords") > -1) && (f.indexOf(days) > -1))
   }

   toggle($event: JQueryCustomEventObject, facet: any) {
      $event?.preventDefault()
      const {
         days
      } = facet
      if (this.isRangeSelectedByScope(days)) {
         this.searchScopeService.clearScopeAsSideEffect()
         return
      }
      const setState = () => {
         if (this.isRangeSelected(days)) {
            // it is selected, so clear it
            this.appState.params.rf = _(this.appState.params.rf).reject((f: any) => f.indexOf("NewRecords") === 0)
            return this.events.gaPush('refinements', 'clear', 'NewRecords')
         } else {
            // else set the new value
            this.appState.params.rf = _(this.appState.params.rf).reject((f: any) => f.indexOf("NewRecords") === 0)
            this.appState.params.rf.push(`NewRecords,${days}:*`)
            return this.events.gaPush('refinements', 'add', this.appState.params.rf)
         }
      }

      return this.appState.applyStateWithSnapShot(setState)
   }
}

DaysOldController.$inject = ['$scope', 'appStateService', 'eventService', 'searchScopeService']

angular.module('summonApp.directives')
   .controller('daysOldController', DaysOldController)
   .directive('daysOld', [DaysOldDirective])
